"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestimonialsComponent = void 0;
var testimonials_1 = require("./testimonials");
Object.defineProperty(exports, "TestimonialsComponent", { enumerable: true, get: function () { return testimonials_1.TestimonialsComponent; } });
